"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAndGetGoogleDrivePreviewableUrl = exports.canPlay = void 0;
var react_player_1 = __importDefault(require("react-player"));
var canPlay = function (value) { return react_player_1.default.canPlay(value); };
exports.canPlay = canPlay;
var verifyAndGetGoogleDrivePreviewableUrl = function (url) {
    var driveUrlPattern = /^(https:\/\/)?(drive\.google\.com\/)(file\/d\/|open\?id=|uc\?export=download&id=)/;
    var isValidDriveUrl = driveUrlPattern.test(url);
    var urlDetails = {
        isPreviewableGoogleDriveUrl: false,
    };
    if (isValidDriveUrl) {
        // converting the input URL to the format that can be previewed with iframe
        // this regex works even if the user provide the previewable url by default as we are checking 'preview' also here
        var fileIdPattern = /\/file\/d\/(.*?)\/(view|edit|preview)/; // Match the fileId between '/file/d/' and '/view', 'edit' or '/preview'
        var fileIdMatch = url.match(fileIdPattern);
        var fileId = fileIdMatch === null || fileIdMatch === void 0 ? void 0 : fileIdMatch[1];
        if (fileId) {
            urlDetails.googleDrivePreviewableUrl = "https://drive.google.com/file/d/".concat(fileId, "/preview");
            urlDetails.isPreviewableGoogleDriveUrl = true;
        }
    }
    return urlDetails;
};
exports.verifyAndGetGoogleDrivePreviewableUrl = verifyAndGetGoogleDrivePreviewableUrl;
